import React from 'react'
import { TippspielSportProps } from '@sport1/types/web'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import Font from '@sport1/news-styleguide/Font'
import SmallButton from '@sport1/news-styleguide/SmallButton'
import CardHeadline from '@sport1/news-styleguide/CardHeadline'
import { sport1Regular } from '@/helpers/fonts'

const TippspielSport = ({ headline, text, buttonTitle, buttonUrl }: TippspielSportProps) => (
    <NonFlexingContainer paddingX={['spacing-6', 'spacing-6', 'spacing-9', 'spacing-none']}>
        <NonFlexingContainer marginBottom="spacing-6">
            <CardHeadline
                text={headline}
                cardHeadlineType={['cardHeadlineS', 'cardHeadlineM', 'cardHeadlineS']}
            />
        </NonFlexingContainer>
        <NonFlexingContainer backgroundColor="pearl" marginBottom="spacing-9" padding="spacing-6">
            <Font
                fontSize="font-size-5"
                nextFontFamilyVariant={sport1Regular.style.fontFamily}
                lineHeight="lineHeight-24"
                paddingBottom="spacing-7"
            >
                {text}
            </Font>
            <SmallButton expand backgroundColor="moon-2" href={buttonUrl} webTarget="_blank">
                {buttonTitle}
            </SmallButton>
        </NonFlexingContainer>
    </NonFlexingContainer>
)

export default TippspielSport
